import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';

import './Politici.css';

export default function Termeni() {
    return (
        <Container className="politiciContainer worldwide">
            <p className="politiciTitle">
                <span className="bracket">{'<'}</span>
                    Termeni și Condiții
                <span className="bracket">{'/>'}</span>
            </p>
            <p className="politiciSubTitle">Regulile de utilizare ale site-ului și serviciilor</p>
            <Row>
                <div className="politiciText">
                    <p>
                        Utilizarea site-ului <strong>info-cu-toni.ro</strong> implică acceptarea termenilor de mai jos.
                        Site-ul este operat de <strong>CRANTEA ANTONIO-CRISTIAN PERSOANĂ FIZICĂ AUTORIZATĂ</strong>, cu
                        sediul în <strong> București, România</strong>.
                    </p>

                    <h4>1. Scopul site-ului</h4>
                    <p>
                        Acest site oferă informații, resurse și posibilitatea de programare pentru servicii de
                        meditații la <strong>Informatică & TIC / Matematică / Programare</strong>, desfășurate <strong>online</strong>.
                    </p>

                    <h4>2. Programări</h4>
                    <p>Programările se pot realiza prin:</p>
                    <ul>
                        <li>formularul de contact de pe site</li>
                        <li>email</li>
                        <li>alte rețele de socializare</li>
                    </ul>

                    <h4>3. Politica de anulare</h4>
                    <p>
                        Anularea unei ședințe este permisă cu <strong>24 de ore</strong> înainte de ora programată.
                        Dacă anularea se face după această perioadă sau elevul nu se prezintă,
                        ședința este considerată efectuată.
                    </p>

                    <h4>4. Plăți și Facturare</h4>
                    <p>Modalitățile de plată acceptate includ:</p>
                    <ul>
                        <li>plată online (Revolut)</li>
                        <li>transfer bancar</li>
                        <li>numerar (dacă este cazul)</li>
                    </ul>
                    <p>
                        Pentru fiecare achiziție se poate emite o factură la cererea clientului,
                        pe baza datelor de facturare furnizate.
                    </p>

                    <h4>5. Drepturi de autor</h4>
                    <p>
                        Toate materialele de pe acest site-texte, imagini, elemente grafice, fișiere PDF,
                        materiale educaționale-sunt protejate de drepturile de autor și aparțin
                        <strong> CRANTEA ANTONIO-CRISTIAN PERSOANĂ FIZICĂ AUTORIZATĂ</strong>.
                    </p>
                    <p>
                        Copierea, distribuirea sau publicarea materialelor fără acord explicit este interzisă.
                    </p>

                    <h4>6. Limitarea răspunderii</h4>
                    <p>
                        Nu garantăm că site-ul va funcționa fără întreruperi sau erori.
                        Nu ne asumăm răspunderea pentru eventualele pierderi cauzate de:
                    </p>
                    <ul>
                        <li>erori tehnice</li>
                        <li>informații interpretate greșit de utilizator</li>
                        <li>probleme de acces la internet</li>
                    </ul>

                    <h4>7. Linkuri către alte site-uri</h4>
                    <p>
                        Site-ul poate conține linkuri către platforme externe (ex: Google Meet, Zoom,
                        Facebook, Instagram). Aceste site-uri au propriile politici și termeni,
                        iar noi nu suntem responsabili pentru conținutul lor.
                    </p>

                    <h4>8. Date personale</h4>
                    <p>
                        Colectarea și procesarea datelor personale se face în conformitate cu
                        Politica de Confidențialitate, disponibilă pe site.
                    </p>

                    <h4>9. Modificarea termenilor</h4>
                    <p>
                        Ne rezervăm dreptul de a modifica acești termeni în orice moment.
                        Actualizarea va fi afișată pe această pagină, împreună cu data ultimei modificări.
                    </p>

                    <h4>10. Contact</h4>
                    <p>
                        Pentru întrebări sau clarificări legate de acești termeni, ne poți contacta la:
                        <br/>
                        <strong>antoniocrantea@gmail.com</strong>
                    </p>
                </div>
            </Row>
        </Container>
    );
}
